import { SuggestedMessaging, SuggestedMessagingSchema } from "../../models/uv-inserts/suggested-messaging"
import { SuggestedMessagingDTO } from "./types"

export const transformRawToSuggestedMessaging = ({
  dto
}: { dto?: SuggestedMessagingDTO[] }): SuggestedMessaging => {
  let schemaInput: SuggestedMessaging = [];
  if(!dto) return schemaInput;

  dto.forEach((item) => {
    schemaInput.push({
      name: item?.name ?? "",
      suggestions: item?.suggestions ?? [],
      area: (item?.area ?? []) as SuggestedMessaging[0]['area'],
      priority: item?.priority ?? 0,
      marketSegment: item?.marketSegment ?? []
    })
  })

  const sortedSchemaInput = schemaInput
    .map((group, index) => ({ group, index }))
    .sort((a, b) => {
      if (a.group.priority === b.group.priority) {
        return a.index - b.index
      }

      return b.group.priority - a.group.priority
    })
    .map(({ group }) => group)

  return SuggestedMessagingSchema.parse(sortedSchemaInput)
}